import type { AdminToastState } from './adminToastTypes';

export function AdminToast({ onClose, toast }: { toast: AdminToastState; onClose: () => void }) {
    if (!toast.show) return null;

    return (
        <div className="fixed bottom-4 left-4 z-[60]">
            <div
                className={`flex max-w-sm items-center rounded-lg border px-4 py-3 shadow-lg ${
                    toast.type === 'success'
                        ? 'border-green-200 bg-green-50 text-green-800'
                        : toast.type === 'warning'
                          ? 'border-amber-200 bg-amber-50 text-amber-900'
                          : 'border-red-200 bg-red-50 text-red-800'
                }`}
            >
                <span className="mr-2 shrink-0" aria-hidden="true">
                    {toast.type === 'success' ? '✅' : toast.type === 'warning' ? '⚠️' : '❌'}
                </span>
                <span className="text-sm font-medium">{toast.message}</span>
                <button
                    type="button"
                    onClick={onClose}
                    className="ml-3 text-neutral-400 hover:text-neutral-700"
                    aria-label="Dismiss notification"
                >
                    ×
                </button>
            </div>
        </div>
    );
}
